import {
    GET_APPOINTMENT, SET_LONG_TOKEN,
} from '../constants/actionTypes'

const initialState = {
    editAppointment:null
};

const appointEditReducer = (state = initialState, action) => {

    //console.log("action---",action);
    switch (action.type) {
        case GET_APPOINTMENT:
            return {
                ...state,
                editAppointment: action.payload,
            };
        case SET_LONG_TOKEN:
            return {
                ...state,
                longToken: action.payload,
            };
        default:
            return state;
    }
};

export default appointEditReducer;